export const UnitsOfMeasure = {
    "1": "spray pequeño",
    "2": "levantar",
    "3": "Lote calor",
    "4": "grupo",
    "5": "equipar",
    "6": "ración",
    "7": "Disparo",
    "8": "palo",
    "9": "tambor de ciento quince kg",
    "10": "tambor de cien libras",
    "11": "tambor de cincuenta y cinco galones (US)",
    "12": "camión cisterna",
    "13": "contenedor de veinte pies",
    "14": "contenedor de cuarenta pies",
    "15": "decilitro por gramo",
    "16": "gramo por centímetro cúbico",
    "17": "libra teórica",
    "18": "gramo por centímetro cuadrado",
    "19": "tonelada real",
    "20": "tonelada teórica",
    "21": "kilogramo por metro cuadrado",
    "22": "libra por mil pies cuadrados",
    "23": "Día de potencia del caballo por tonelada métrica seca al aire.",
    "24": "coger peso",
    "25": "kilogramo por aire seco tonelada métrica",
    "26": "kilopascales metros cuadrados por gramo",
    "27": "kilopascales por milímetro",
    "28": "mililitros por centímetro cuadrado segundo",
    "29": "pies cúbicos por minuto por pie cuadrado",
    "30": "onza por pie cuadrado",
    "31": "onzas por pie cuadrado por 0,01 pulgadas",
    "32": "mililitro por segundo",
    "33": "mililitro por minuto",
    "34": "bolsa súper a granel",
    "35": "bolsa a granel de quinientos kg",
    "36": "bolsa a granel de trescientos kg",
    "37": "bolsa a granel de cincuenta libras",
    "38": "bolsa de cincuenta libras",
    "39": "carga de automóviles a granel",
    "40": "kilogramos teóricos",
    "41": "tonelada teórica",
    "42": "sitas",
    "43": "malla",
    "44": "kilogramo neto",
    "45": "parte por millón",
    "46": "porcentaje de peso",
    "47": "parte por billón (US)",
    "48": "porcentaje por 1000 horas",
    "49": "tasa de fracaso en el tiempo",
    "50": "libra por pulgada cuadrada, calibre",
    "51": "Oersted",
    "52": "prueba de escala específica",
    "53": "voltio amperio por libra",
    "54": "vatio por libra",
    "55": "amperio tum por centímetro",
    "56": "milipascal",
    "57": "gauss",
    "58": "mili pulgadas",
    "59": "kilogauss",
    "60": "libras por pulgada cuadrada absoluta",
    "61": "Enrique",
    "62": "kilopound por pulgada cuadrada",
    "63": "fuerza libra pie",
    "64": "libra por pie cúbico",
    "65": "equilibrio",
    "66": "Saybold segundo universal",
    "67": "alimenta",
    "68": "calorías por centímetro cúbico",
    "69": "calorías por gramo",
    "70": "Unidad",
    "71": "veinte mil galones (US) de carros",
    "72": "diez mil galones (US) de carros",
    "73": "tambor de diez kg",
    "74": "tambor de quince kg",
    "75": "milla de coche",
    "76": "recuento de coches",
    "77": "recuento de locomotoras",
    "78": "recuento de cabos",
    "79": "carro vacio",
    "80": "millas de tren",
    "81": "uso de combustible galón (US)",
    "82": "milla del caboose",
    "83": "tipo de interés fijo",
    "84": "tonelada milla",
    "85": "milla locomotora",
    "86": "recuento total de coches",
    "87": "milla de coche total",
    "88": "cuarto de milla",
    "89": "radianes por segundo",
    "90": "radianes por segundo al cuadrado",
    "91": "Röntgen",
    "92": "Unidad térmica británica por hora.",
    "93": "centímetro cúbico por segundo",
    "94": "pie cúbico por hora",
    "95": "pie cúbico por minuto",
    "96": "centímetro por segundo",
    "97": "decibel",
    "98": "kilobyte",
    "99": "kilobecquerel",
    "100": "kilocurie",
    "101": "megagramo",
    "102": "megagramo por hora",
    "103": "compartimiento",
    "104": "metro por minuto",
    "105": "milliröntgen",
    "106": "milivoltios",
    "107": "megajulio",
    "108": "manmonth",
    "109": "libra por libra de producto",
    "110": "libra por pieza de producto",
    "111": "kilogramo por kilogramo de producto",
    "112": "kilogramo por pieza de producto",
    "113": "bobina",
    "114": "gorra",
    "115": "centistokes",
    "116": "paquete de veinte",
    "117": "microlitro",
    "118": "micrometro",
    "119": "miliamperio",
    "120": "megabyte",
    "121": "miligramo por hora",
    "122": "megabecquerel",
    "123": "microfarad",
    "124": "newton por metro",
    "125": "onza pulgada",
    "126": "pie onza",
    "127": "picofarad",
    "128": "libra por hora",
    "129": "tonelada (US) por hora",
    "130": "kilolitro por hora",
    "131": "barril por minuto",
    "132": "lote",
    "133": "galón (US) por mil",
    "134": "MMSCF / día",
    "135": "libras por mil",
    "136": "bomba",
    "137": "escenario",
    "138": "pie cúbico estándar",
    "139": "potencia hidráulica de caballos",
    "140": "contar por minuto",
    "141": "nivel sismico",
    "142": "nfor sismica",
    "143": "15 calorías C",
    "144": "amperio metro cuadrado por joule segundo",
    "145": "Ã ¥ ngström",
    "146": "unidad astronómica",
    "147": "attojoule",
    "148": "granero",
    "149": "granero por electrón voltio",
    "150": "granero por voltio de electrones esteradiano,",
    "151": "granero por sterdian",
    "152": "becquerel por kilogramo",
    "153": "becquerel por metro cúbico",
    "154": "amperio por centímetro",
    "155": "Unidad térmica británica por segundo pie cuadrado grado Rankin",
    "156": "Unidad térmica británica por libra grado Rankin",
    "157": "Unidad térmica británica por segundo pie grado Rankin",
    "158": "Unidad térmica británica por hora pie cuadrado grado Rankin",
    "159": "candela por metro cuadrado",
    "160": "cheval vapeur",
    "161": "medidor de culombio",
    "162": "medidor de culombio al cuadrado por voltio",
    "163": "Coulomb por centímetro cúbico",
    "164": "Coulomb por metro cúbico",
    "165": "amperio por milímetro",
    "166": "Coulomb por milímetro cúbico",
    "167": "Coulomb por kilogramo segundo",
    "168": "Coulomb por mol",
    "169": "Coulomb por centímetro cuadrado",
    "170": "Coulomb por metro cuadrado",
    "171": "Coulomb por milímetro cuadrado",
    "172": "centímetro cúbico por mol",
    "173": "nformaci cúbico por mol",
    "174": "metro cúbico por coulomb",
    "175": "metro cúbico por kilogramo",
    "176": "amperio por centímetro cuadrado",
    "177": "metro cúbico por mol",
    "178": "amperio por metro cuadrado",
    "179": "curie por kilogramo",
    "180": "tonelaje de peso muerto",
    "181": "decalitro",
    "182": "decámetro",
    "183": "decitex",
    "184": "grado Rankin",
    "185": "negador",
    "186": "amperio metro cuadrado",
    "187": "dyn segundo por centímetro cúbico",
    "188": "dina segundo por centímetro",
    "189": "dina segundo por centímetro al quinto",
    "190": "electronvolt",
    "191": "electronvoltio por metro",
    "192": "metro electronvolt cuadrado",
    "193": "electronvoltio de metro cuadrado por kilogramo",
    "194": "ergio",
    "195": "erg por centímetro",
    "196": "amperio por metro cuadrado kelvin al cuadrado",
    "197": "erg por centímetro cúbico",
    "198": "erg por gramo",
    "199": "erg por gramo de segundo",
    "200": "erg por segundo",
    "201": "erg por segundo centímetro cuadrado",
    "202": "erg por centímetro cuadrado segundo",
    "203": "erg centímetro cuadrado",
    "204": "ergímetro cuadrado por gramo",
    "205": "exajulio",
    "206": "faradio por metro",
    "207": "amperio por milímetro cuadrado",
    "208": "femtojoule",
    "209": "femtometro",
    "210": "pie por segundo al cuadrado",
    "211": "pie-fuerza de la libra por segundo",
    "212": "tonelada de carga",
    "213": "galón",
    "214": "Unidad de desplazamiento CGS gaussiana",
    "215": "Unidad gaussiana CGS de corriente eléctrica.",
    "216": "Unidad Gaussian CGS de carga eléctrica.",
    "217": "amperio segundo",
    "218": "Unidad Gaussian CGS de intensidad de campo eléctrico.",
    "219": "Unidad Gaussian CGS de polarización eléctrica.",
    "220": "Unidad Gaussian CGS de potencial eléctrico.",
    "221": "Unidad Gaussiana CGS de magnetización.",
    "222": "gigacoulomb por metro cúbico",
    "223": "Gigaelectronvolt",
    "224": "gigahercios",
    "225": "gigaohm",
    "226": "medidor de gigaohm",
    "227": "gigapascal",
    "228": "tarifa",
    "229": "gigavatios",
    "230": "gon",
    "231": "gramo por metro cúbico",
    "232": "gramo por mol",
    "233": "gris",
    "234": "gris por segundo",
    "235": "hectopascal",
    "236": "Henry por metro",
    "237": "bola",
    "238": "paquete a granel",
    "239": "acre",
    "240": "byte",
    "241": "amperio por metro",
    "242": "minuto adicional",
    "243": "minuto promedio por llamada",
    "244": "policía",
    "245": "braza",
    "246": "nfor de acceso",
    "247": "ampolla",
    "248": "hora amperio",
    "249": "amperio",
    "250": "año",
    "251": "solo libra de aluminio",
    "252": "onza troy o onza de boticarios",
    "253": "Unidad de factor antihemofílico (AHF)",
    "254": "supositorio",
    "255": "son",
    "256": "surtido",
    "257": "fuerza alcohólica en masa",
    "258": "fuerza alcohólica por volumen",
    "259": "ambiente estándar",
    "260": "ambiente técnico",
    "261": "cápsula",
    "262": "vial lleno de polvo",
    "263": "montaje",
    "264": "Unidad térmica británica por libra",
    "265": "Btu por pie cúbico",
    "266": "barril (US) por día",
    "267": "julios por kilogramo kelvin",
    "268": "julios por metro",
    "269": "julios por metro cuadrado",
    "270": "julios por metro a la cuarta potencia",
    "271": "julios por mol",
    "272": "julios por mol kelvin",
    "273": "joule segundo",
    "274": "litera",
    "275": "joule metro cuadrado por kilogramo",
    "276": "kelvin por vatio",
    "277": "Kiloampere",
    "278": "kiloampere por metro cuadrado",
    "279": "kiloampere por metro",
    "280": "kilobecquerel por kilogramo",
    "281": "kilocoulomb",
    "282": "kilocoulomb por metro cúbico",
    "283": "kilocoulomb por metro cuadrado",
    "284": "kiloelectronvolt",
    "285": "libra de bateo",
    "286": "kilogramo metro por segundo",
    "287": "kilogramo metro cuadrado",
    "288": "kilogramo metro cuadrado por segundo",
    "289": "kilogramo por decímetro cúbico",
    "290": "kilogramo por litro",
    "291": "caloría termoquímica por gramo",
    "292": "kilogramo de fuerza",
    "293": "metro de fuerza de kilogramo",
    "294": "metro de fuerza de kilogramo por segundo",
    "295": "barril, imperial",
    "296": "kilogramo de fuerza por metro cuadrado",
    "297": "kilojoule per kelvin",
    "298": "kilojoule por kilogramo",
    "299": "kilojoule por kilogramo kelvin",
    "300": "kilojoule por mol",
    "301": "kilomol",
    "302": "kilomol por metro cúbico",
    "303": "Kilonewton",
    "304": "medidor de kilonewton",
    "305": "kiloohm",
    "306": "palanquilla",
    "307": "medidor de kiloohm",
    "308": "kilopond",
    "309": "kilosegundo",
    "310": "kilosiemens",
    "311": "kilosiemens por metro",
    "312": "kilovoltios por metro",
    "313": "kiloveber por metro",
    "314": "año luz",
    "315": "litro por mol",
    "316": "hora lumen",
    "317": "bollo",
    "318": "lumen por metro cuadrado",
    "319": "lumen por vatio",
    "320": "lumen segundo",
    "321": "hora de lux",
    "322": "lux segundo",
    "323": "Maxwell",
    "324": "megaamperios por metro cuadrado",
    "325": "megabecquerel por kilogramo",
    "326": "megacoulomb por metro cúbico",
    "327": "ciclo",
    "328": "megacoulomb por metro cuadrado",
    "329": "megaelectronvolt",
    "330": "megagramo por metro cúbico",
    "331": "meganewton",
    "332": "medidor de meganewton",
    "333": "megaohm",
    "334": "metro megaohm",
    "335": "megasiemens por metro",
    "336": "megavoltio",
    "337": "megavolt por metro",
    "338": "julios por metro cúbico",
    "339": "metro recíproco cuadrado recíproco segundo",
    "340": "metro a la cuarta potencia",
    "341": "microamperios",
    "342": "microbar",
    "343": "microcoulomb",
    "344": "microcoulomb por metro cúbico",
    "345": "microcoulomb por metro cuadrado",
    "346": "microfarada por metro",
    "347": "batt",
    "348": "microhenry",
    "349": "microhenry por metro",
    "350": "micronewton",
    "351": "medidor de micronewton",
    "352": "microohm",
    "353": "medidor de microohmios",
    "354": "micropascal",
    "355": "microradiano",
    "356": "microsegundo",
    "357": "microsiemens",
    "358": "bar",
    "359": "caja base",
    "360": "tablero",
    "361": "haz",
    "362": "pie de tabla",
    "363": "bolso",
    "364": "cepillo",
    "365": "potencia al freno",
    "366": "trillón de dólares",
    "367": "cangilón",
    "368": "cesta",
    "369": "bala",
    "370": "barril seco",
    "371": "barril (EE. UU.) (petróleo, etc.)",
    "372": "botella",
    "373": "cien pies de tabla",
    "374": "becquerel",
    "375": "bar",
    "376": "tornillo",
    "377": "Unidad Térmica Británica",
    "378": "bushel (EE. UU.)",
    "379": "bushel (Reino Unido)",
    "380": "peso base",
    "381": "caja",
    "382": "millones de BTUs",
    "383": "llamada",
    "384": "producto compuesto libra (peso total)",
    "385": "millifarad",
    "386": "miligal",
    "387": "miligramo por metro",
    "388": "miligray",
    "389": "milihenry",
    "390": "milijoule",
    "391": "milímetro por segundo",
    "392": "milímetro cuadrado por segundo",
    "393": "milimol",
    "394": "mol por kilogramo",
    "395": "carset",
    "396": "millinewton",
    "397": "millinewton por metro",
    "398": "medidor de miliohm",
    "399": "segundo milipascal",
    "400": "miliradian",
    "401": "milisegundo",
    "402": "milisiemens",
    "403": "milisievert",
    "404": "millitesla",
    "405": "microvoltios por metro",
    "406": "milivoltios por metro",
    "407": "milivatios",
    "408": "milivatios por metro cuadrado",
    "409": "milliweber",
    "410": "Topo",
    "411": "mol por decímetro cúbico",
    "412": "mol por metro cúbico",
    "413": "mol por litro",
    "414": "Nanoampere",
    "415": "partido de carga",
    "416": "nanocoulomb",
    "417": "nanofarad",
    "418": "nanofarad por metro",
    "419": "nanohenry",
    "420": "nanohenry por metro",
    "421": "nanometro",
    "422": "medidor de nanoohm",
    "423": "nanosegundo",
    "424": "nanotesla",
    "425": "nanovatio",
    "426": "costo",
    "427": "neper",
    "428": "neper por segundo",
    "429": "picometro",
    "430": "metro de newton segundo",
    "431": "newton metro cuadrado kilogramo cuadrado",
    "432": "newton por metro cuadrado",
    "433": "newton por milímetro cuadrado",
    "434": "newton segundo",
    "435": "newton segundo por metro",
    "436": "octava",
    "437": "célula",
    "438": "ohm centímetro",
    "439": "ohm metro",
    "440": "uno",
    "441": "parsec",
    "442": "pascal por kelvin",
    "443": "segundo pascal",
    "444": "segundo pascal por metro cúbico",
    "445": "segundo pascal por metro",
    "446": "petajoule",
    "447": "telefono",
    "448": "centipoise",
    "449": "picoampere",
    "450": "picocoulomb",
    "451": "picofarad por metro",
    "452": "picohenry",
    "453": "picowatt",
    "454": "picowatt por metro cuadrado",
    "455": "medidor de libras",
    "456": "fuerza de libra",
    "457": "Millicoulomb por kilogramo",
    "458": "rad",
    "459": "radián",
    "460": "medidor de radianes al cuadrado por mol",
    "461": "medidor de radianes al cuadrado por kilogramo",
    "462": "radian por metro",
    "463": "â € ngstr recíproco “m",
    "464": "metro cúbico recíproco",
    "465": "metro cúbico recíproco por segundo",
    "466": "voltios de electrones recíprocos por metro cúbico",
    "467": "Henry Recíproco",
    "468": "grupo de bobina",
    "469": "Joule recíproco por metro cúbico",
    "470": "kelvin recíproco o kelvin al poder menos uno",
    "471": "medidor recíproco",
    "472": "metro cuadrado recíproco",
    "473": "minuto recíproco",
    "474": "mole recíproco",
    "475": "Pascal recíproco o pascal a la potencia menos uno.",
    "476": "segundo recíproco",
    "477": "segundo recíproco por metro cúbico",
    "478": "segundo recíproco por metro cuadrado",
    "479": "Caja",
    "480": "Capacidad de carga en toneladas métricas.",
    "481": "candela",
    "482": "grado Celsius",
    "483": "cien",
    "484": "tarjeta",
    "485": "centigramo",
    "486": "envase",
    "487": "cono",
    "488": "conector",
    "489": "Coulomb por kilogramo",
    "490": "bobina",
    "491": "cientos de licencia",
    "492": "centilitro",
    "493": "centímetro cuadrado",
    "494": "centímetro cúbico",
    "495": "centímetro",
    "496": "paquete de cien",
    "497": "Cental (Reino Unido)",
    "498": "garrafón",
    "499": "culombio",
    "500": "cartucho",
    "501": "caja",
    "502": "caso",
    "503": "caja de cartón",
    "504": "quilate métrico",
    "505": "vaso",
    "506": "curie",
    "507": "cubrir",
    "508": "cien libras (quintales) / cien pesos (US)",
    "509": "cien pesos (Reino Unido)",
    "510": "cilindro",
    "511": "combo",
    "512": "segundo recíproco por esteradiano",
    "513": "siemens por metro",
    "514": "siemens metro cuadrado por mol",
    "515": "sievert",
    "516": "mil yardas lineales",
    "517": "sone",
    "518": "centímetro cuadrado por ergio",
    "519": "centímetro cuadrado por erg esterlina",
    "520": "metro kelvin",
    "521": "kelvin metro cuadrado por vatio",
    "522": "segundo recíproco por metros cuadrados esteradianos",
    "523": "metro cuadrado por julio",
    "524": "metro cuadrado por kilogramo",
    "525": "metro cuadrado por mol",
    "526": "pluma gramo (proteína)",
    "527": "metro cuadrado por esterilizador",
    "528": "metro cuadrado por julios esteradianos",
    "529": "metro cuadrado por voltio segundo",
    "530": "esteradiano",
    "531": "sifón",
    "532": "terahercios",
    "533": "terajulio",
    "534": "teravatio",
    "535": "hora de teravatio",
    "536": "tesla",
    "537": "Texas",
    "538": "caloría termoquímica",
    "539": "caloría termoquímica por gramo kelvin",
    "540": "calorías termoquímicas por segundo centímetro kelvin",
    "541": "calorías termoquímicas por segundo centímetro cuadrado kelvin",
    "542": "mil litros",
    "543": "tonelada por metro cúbico",
    "544": "año tropical",
    "545": "unidad de masa atómica unificada",
    "546": "var",
    "547": "voltios al cuadrado por kelvin al cuadrado",
    "548": "voltio – amperio",
    "549": "voltio por centímetro",
    "550": "voltio por kelvin",
    "551": "milivoltios por kelvin",
    "552": "kilogramo por centímetro cuadrado",
    "553": "voltios por metro",
    "554": "voltios por milímetro",
    "555": "vatios por kelvin",
    "556": "vatios por metro kelvin",
    "557": "vatios por metro cuadrado",
    "558": "vatios por metro cuadrado kelvin",
    "559": "vatios por metro cuadrado de kelvin a la cuarta potencia",
    "560": "vatios por steradian",
    "561": "vatios por metro cuadrado esterlino",
    "562": "weber por metro",
    "563": "röntgen por segundo",
    "564": "weber por milímetro",
    "565": "minuto",
    "566": "segundo",
    "567": "libro",
    "568": "bloquear",
    "569": "redondo",
    "570": "casete",
    "571": "dólar por hora",
    "572": "pulgada a la cuarta potencia",
    "573": "Sandwich",
    "574": "Tabla Internacional (IT) caloría",
    "575": "Tabla Internacional (IT) calorías por segundo centímetro kelvin",
    "576": "Tabla Internacional (IT) calorías por segundo centímetro cuadrado kelvin",
    "577": "joule metro cuadrado",
    "578": "kilogramo por mol",
    "579": "Tabla Internacional (IT) calorías por gramo",
    "580": "Tabla Internacional (IT) calorías por gramo kelvin",
    "581": "megacoulomb",
    "582": "haz",
    "583": "puntaje de drenaje",
    "584": "microwatt",
    "585": "microtesla",
    "586": "microvoltio",
    "587": "medidor de millinewton",
    "588": "microwatt por metro cuadrado",
    "589": "Millicoulomb",
    "590": "milimol por kilogramo",
    "591": "millicoulomb por metro cúbico",
    "592": "millicoulomb por metro cuadrado",
    "593": "dina por centímetro cuadrado",
    "594": "metro cúbico (neto)",
    "595": "movimiento rápido del ojo",
    "596": "banda",
    "597": "segundo por metro cúbico",
    "598": "segundo por metro cúbico radianes",
    "599": "julios por gramo",
    "600": "libra bruta",
    "601": "carga de palet / unidad",
    "602": "libra de masa",
    "603": "manga",
    "604": "despreciar",
    "605": "diez dias",
    "606": "día",
    "607": "libra seca",
    "608": "disco",
    "609": "la licenciatura",
    "610": "acuerdo",
    "611": "década",
    "612": "decigramo",
    "613": "dispensador",
    "614": "decagramo",
    "615": "decilitro",
    "616": "nformaci cuadrado",
    "617": "decímetro cúbico",
    "618": "decímetro",
    "619": "medidor de decinewton",
    "620": "docena pieza",
    "621": "docena par",
    "622": "tonelaje de desplazamiento",
    "623": "registro de datos",
    "624": "tambor",
    "625": "dram (US)",
    "626": "dram (Reino Unido)",
    "627": "docena rollo",
    "628": "dracma (Reino Unido)",
    "629": "monitor",
    "630": "tonelada seca",
    "631": "Decitonne",
    "632": "dina",
    "633": "pennyweight",
    "634": "dina por centímetro",
    "635": "libro de directorio",
    "636": "docena",
    "637": "paquete de doce",
    "638": "cinturón",
    "639": "remolque",
    "640": "kilogramo bruto",
    "641": "tonelada métrica larga",
    "642": "cada",
    "643": "casilla de correo electrónico",
    "644": "cada uno por mes",
    "645": "paquete de once",
    "646": "galón equivalente",
    "647": "sobre",
    "648": "mil pies cúbicos por día",
    "649": "Fibra por centímetro cúbico de aire",
    "650": "grado Fahrenheit",
    "651": "faradio",
    "652": "campo",
    "653": "mil pies cúbicos",
    "654": "millón de partículas por pie cúbico",
    "655": "pie de pista",
    "656": "cien metros cúbicos",
    "657": "parche transdérmico",
    "658": "micromol",
    "659": "tonelada en escamas",
    "660": "millones de pies cúbicos",
    "661": "pie",
    "662": "libra por pie cuadrado",
    "663": "pie por minuto",
    "664": "pie por segundo",
    "665": "pie cuadrado",
    "666": "pie cubico",
    "667": "US galones por minuto",
    "668": "Galon imperial por minuto",
    "669": "hoja de microficha",
    "670": "galón (US) por día",
    "671": "gigabecquerel",
    "672": "gramo por 100 gramo",
    "673": "barril bruto",
    "674": "libra por galón (US)",
    "675": "gramo por metro (gramo por 100 centímetros)",
    "676": "gramo de isótopo fisionable",
    "677": "gramo",
    "678": "medio galón (EE. UU.)",
    "679": "branquias",
    "680": "Gill (Reino Unido)",
    "681": "gramo por mililitro",
    "682": "gramo por kilogramo",
    "683": "gramo por litro",
    "684": "galón seco (EE. UU.)",
    "685": "galón (Reino Unido)",
    "686": "galón",
    "687": "gramo por metro cuadrado",
    "688": "galón bruto",
    "689": "miligramos por metro cuadrado",
    "690": "miligramo por metro cúbico",
    "691": "microgramos por metro cúbico",
    "692": "gramo",
    "693": "grano",
    "694": "bruto",
    "695": "tonelada de registro bruto",
    "696": "tonelada bruta",
    "697": "gigajoule",
    "698": "galón por mil pies cúbicos",
    "699": "hora de gigavatios",
    "700": "patio bruto",
    "701": "sistema de medición",
    "702": "media página – electrónica",
    "703": "medio litro",
    "704": "madeja",
    "705": "hectárea",
    "706": "hectobar",
    "707": "cien cajas",
    "708": "cien cuentas",
    "709": "media docena",
    "710": "centésima de quilate",
    "711": "cien pies",
    "712": "hectogramo",
    "713": "cien pies cúbicos",
    "714": "cien hojas",
    "715": "cien unidades internacionales",
    "716": "caballo métrico",
    "717": "cien kilogramos",
    "718": "cien pies (lineales)",
    "719": "hectolitro",
    "720": "milla por hora",
    "721": "millones de metros cúbicos",
    "722": "hectómetro",
    "723": "milímetro convencional de mercurio",
    "724": "cien onzas troy",
    "725": "milímetro convencional de agua",
    "726": "hectolitro de alcohol puro",
    "727": "cien pies cuadrados",
    "728": "media hora",
    "729": "hertz",
    "730": "hora",
    "731": "cien yardas",
    "732": "pulgada libra",
    "733": "contar por pulgada",
    "734": "persona",
    "735": "pulgadas de agua",
    "736": "columna pulgada",
    "737": "pulgada por minuto",
    "738": "impresión",
    "739": "pulgada",
    "740": "pulgada cuadrada",
    "741": "pulgada en cubos",
    "742": "póliza de seguros",
    "743": "conteo por centímetro",
    "744": "pulgada por segundo (velocidad lineal)",
    "745": "pulgada por segundo al cuadrado (aceleración)",
    "746": "julios por kilogramo",
    "747": "jumbo",
    "748": "joule por kelvin",
    "749": "jarra",
    "750": "megajulio por kilogramo",
    "751": "megajulio por metro cúbico",
    "752": "articulación",
    "753": "joule",
    "754": "tarro",
    "755": "demanda de kilovatios",
    "756": "kilovoltios amperios reactivos de demanda",
    "757": "kilovoltio amperio hora reactiva",
    "758": "amperios kilovoltios (reactivos)",
    "759": "kilolitro",
    "760": "pastel",
    "761": "kilocharacter",
    "762": "kilobar",
    "763": "kilogramo decimal",
    "764": "kelvin",
    "765": "kilopacket",
    "766": "barrilete",
    "767": "kilogramo",
    "768": "kilogramo por segundo",
    "769": "kilohercio",
    "770": "Kilogramo por milímetro de ancho",
    "771": "kilosegmento",
    "772": "kilojoule",
    "773": "kilogramo por metro",
    "774": "kilómetro por hora",
    "775": "kilometro cuadrado",
    "776": "kilogramo por metro cúbico",
    "777": "kilogramo de nitrógeno",
    "778": "kilogramo de sustancia nombrada",
    "779": "nudo",
    "780": "Milliequivalencia de potasa cáustica por gramo de producto.",
    "781": "kilopascal",
    "782": "kilogramo de hidróxido de potasio (potasa cáustica)",
    "783": "kilogramo de óxido de potasio",
    "784": "kilogramo de pentóxido de fósforo (anhídrido fosfórico)",
    "785": "KilorÃ¶ntgen",
    "786": "mil libras por pulgada cuadrada",
    "787": "kilogramo de sustancia 90% seca",
    "788": "kilogramo de hidróxido de sodio (soda cáustica)",
    "789": "equipo",
    "790": "kilómetro",
    "791": "kilotonne",
    "792": "kilogramo de uranio",
    "793": "kilovoltio – ampere",
    "794": "kilovar",
    "795": "kilovoltio",
    "796": "kilogramos por milímetro",
    "797": "kilovatios hora",
    "798": "kilovatio",
    "799": "mililitro por kilogramo",
    "800": "litro por minuto",
    "801": "libra por pulgada cúbica",
    "802": "libra",
    "803": "libra troy",
    "804": "centímetro lineal",
    "805": "litro por día",
    "806": "lite",
    "807": "hoja",
    "808": "pie lineal",
    "809": "hora de trabajo",
    "810": "pulgada lineal",
    "811": "spray grande",
    "812": "enlazar",
    "813": "metro lineal",
    "814": "longitud",
    "815": "mucho",
    "816": "libra liquida",
    "817": "litro de alcohol puro",
    "818": "capa",
    "819": "Suma global",
    "820": "ton (Reino Unido) o longton (EE. UU.)",
    "821": "litro",
    "822": "lumen",
    "823": "lux",
    "824": "yarda lineal por libra",
    "825": "yarda lineal",
    "826": "cinta magnética",
    "827": "miligramos por litro",
    "828": "valor monetario",
    "829": "microcurie",
    "830": "micropulgada",
    "831": "millones de Btu por 1000 pies cúbicos",
    "832": "máquina por unidad",
    "833": "mega litro",
    "834": "megametro",
    "835": "megavatio",
    "836": "mil equivalentes de ladrillo estándar",
    "837": "mil pies de tabla",
    "838": "milibar",
    "839": "microgramo",
    "840": "milicurie",
    "841": "aire seco tonelada métrica",
    "842": "miligramo por pie cuadrado por lado",
    "843": "miligramo",
    "844": "megahercio",
    "845": "milla cuadrada",
    "846": "mil",
    "847": "minuto",
    "848": "millón",
    "849": "millones de unidades internacionales",
    "850": "miligramo por pulgada cuadrada",
    "851": "mil millones",
    "852": "mililitro",
    "853": "milímetro cuadrado",
    "854": "milímetro cúbico",
    "855": "milímetro",
    "856": "mes",
    "857": "megapascal",
    "858": "mil metros",
    "859": "metro cúbico por hora",
    "860": "metro cúbico por segundo",
    "861": "metro por segundo al cuadrado",
    "862": "estera",
    "863": "metro cuadrado",
    "864": "Metro cúbico",
    "865": "metro",
    "866": "metro por segundo",
    "867": "numero de mults",
    "868": "megavolt – ampere",
    "869": "megavatios hora (1000 kW.h)",
    "870": "calorías de la pluma",
    "871": "número de líneas",
    "872": "punto de impresión",
    "873": "miligramo por kilogramo",
    "874": "número de artículos",
    "875": "barcaza",
    "876": "número de bobinas",
    "877": "coche",
    "878": "número de celdas",
    "879": "barril neto",
    "880": "litro neto",
    "881": "newton",
    "882": "mensaje",
    "883": "galón neto (nosotros)",
    "884": "hora del mensaje",
    "885": "galón imperial neto",
    "886": "número de unidades internacionales",
    "887": "número de pantallas",
    "888": "carga",
    "889": "milla nautica",
    "890": "número de paquetes",
    "891": "entrenar",
    "892": "número de parcelas",
    "893": "numero de pares",
    "894": "numero de partes",
    "895": "mho",
    "896": "micromho",
    "897": "número de rollos",
    "898": "tonelada neta",
    "899": "registro neto de toneladas",
    "900": "medidor de newton",
    "901": "vehículo",
    "902": "parte por mil",
    "903": "libra por aire seco tonelada métrica",
    "904": "panel",
    "905": "ohm",
    "906": "onza por yarda cuadrada",
    "907": "onza",
    "908": "Dos paquetes",
    "909": "hora extra",
    "910": "onza av",
    "911": "onza líquida (US)",
    "912": "onza líquida (Reino Unido)",
    "913": "pagina – electronica",
    "914": "por ciento",
    "915": "libra por pie",
    "916": "paquete de tres",
    "917": "paquete de cuatro",
    "918": "paquete de cinco",
    "919": "paquete de seis",
    "920": "paquete de siete",
    "921": "paquete de ocho",
    "922": "paquete de nueve",
    "923": "paquete",
    "924": "pascal",
    "925": "par de pulgadas",
    "926": "almohadilla",
    "927": "equivalente en libras",
    "928": "palet (ascensor)",
    "929": "plato",
    "930": "galón de prueba",
    "931": "tono",
    "932": "paquete",
    "933": "cubo",
    "934": "porcentaje de libra",
    "935": "libra neta",
    "936": "libra por pulgada de longitud",
    "937": "página por pulgada",
    "938": "par",
    "939": "fuerza de libra por pulgada cuadrada",
    "940": "pinta",
    "941": "pinta seca",
    "942": "pinta (Reino Unido)",
    "943": "pinta liquida (US)",
    "944": "bandeja / paquete de bandeja",
    "945": "media pinta (US)",
    "946": "libra por pulgada de ancho",
    "947": "Peck Dry (US)",
    "948": "Peck Dry (Reino Unido)",
    "949": "comida",
    "950": "página – facsímil",
    "951": "cuarto (de un año)",
    "952": "página – copia impresa",
    "953": "cuarto de docena",
    "954": "un cuarto de hora",
    "955": "cuarto de kilogramo",
    "956": "mano de papel",
    "957": "cuarto de galón (US)",
    "958": "cuarto seco (EE. UU.)",
    "959": "cuarto de galón (Reino Unido)",
    "960": "cuarto líquido (US)",
    "961": "cuarto (UK)",
    "962": "pica",
    "963": "caloría",
    "964": "mil metros cúbicos",
    "965": "estante",
    "966": "barra",
    "967": "anillo",
    "968": "hora de funcionamiento o de funcionamiento",
    "969": "medida métrica rollo",
    "970": "carrete",
    "971": "resma",
    "972": "medida métrica de resma",
    "973": "rodar",
    "974": "libra por resma",
    "975": "revoluciones por minuto",
    "976": "revoluciones por segundo",
    "977": "Reiniciar",
    "978": "ingreso tonelada milla",
    "979": "correr",
    "980": "pie cuadrado por segundo",
    "981": "metro cuadrado por segundo",
    "982": "sesenta cuartos de pulgada",
    "983": "sesión",
    "984": "unidad de almacenamiento",
    "985": "unidad de publicidad estándar",
    "986": "saco",
    "987": "medio año (6 meses)",
    "988": "Puntuación",
    "989": "escrúpulo",
    "990": "libra solida",
    "991": "sección",
    "992": "segundo",
    "993": "conjunto",
    "994": "segmento",
    "995": "tonelada de envío",
    "996": "siemens",
    "997": "camión cisterna dividido",
    "998": "hoja de deslizamiento",
    "999": "milla (milla estatutaria)",
    "1000": "varilla cuadrada",
    "1001": "carrete",
    "1002": "paquete de estante",
    "1003": "cuadrado",
    "1004": "tira",
    "1005": "hoja métrica medida",
    "1006": "corto estándar (7200 partidos)",
    "1007": "hoja",
    "1008": "piedra (Reino Unido)",
    "1009": "tonelada (US) o tonelada corta (UK / US)",
    "1010": "patinar",
    "1011": "madeja",
    "1012": "envío",
    "1013": "Línea de telecomunicaciones en servicio.",
    "1014": "mil libras brutas",
    "1015": "mil piezas",
    "1016": "bolsa de mil",
    "1017": "caja de mil",
    "1018": "mil galones (US)",
    "1019": "mil impresiones",
    "1020": "mil pulgadas lineales",
    "1021": "décimo pie cúbico",
    "1022": "Kiloampere hora (mil amperios hora)",
    "1023": "camion",
    "1024": "termia",
    "1025": "totalizador",
    "1026": "diez metros cuadrados",
    "1027": "mil pulgadas cuadradas",
    "1028": "mil centímetros cuadrados",
    "1029": "tanque, rectangular",
    "1030": "mil pies (lineales)",
    "1031": "estaño",
    "1032": "tonelada (tonelada métrica)",
    "1033": "paquete de diez",
    "1034": "diez pares",
    "1035": "mil pies",
    "1036": "mil metros cúbicos por día",
    "1037": "diez pies cuadrados",
    "1038": "trillón (EUR)",
    "1039": "mil pies cuadrados",
    "1040": "tonelada de sustancia 90% seca",
    "1041": "tonelada de vapor por hora",
    "1042": "mil metros lineales",
    "1043": "tubo",
    "1044": "mil kilogramos",
    "1045": "mil hojas",
    "1046": "tanque, cilíndrico",
    "1047": "tratamiento",
    "1048": "tableta",
    "1049": "torr",
    "1050": "Línea de telecomunicaciones en servicio promedio.",
    "1051": "puerto de telecomunicaciones",
    "1052": "décimo minuto",
    "1053": "décima hora",
    "1054": "uso por línea de telecomunicación promedio",
    "1055": "diez mil yardas",
    "1056": "millones de unidades",
    "1057": "voltio amperio por kilogramo",
    "1058": "frasco",
    "1059": "voltio",
    "1060": "abultar",
    "1061": "visitar",
    "1062": "kilo mojado",
    "1063": "dos semanas",
    "1064": "vatio por kilogramo",
    "1065": "libra mojada",
    "1066": "cable",
    "1067": "tonelada mojada",
    "1068": "weber",
    "1069": "semana",
    "1070": "galon de vino",
    "1071": "rueda",
    "1072": "vatios hora",
    "1073": "peso por pulgada cuadrada",
    "1074": "mes de trabajo",
    "1075": "envolver",
    "1076": "estándar",
    "1077": "vatio",
    "1078": "mililitro de agua",
    "1079": "cadena",
    "1080": "yarda cuadrada",
    "1081": "Yarda cúbica",
    "1082": "cien yardas lineales",
    "1083": "yarda",
    "1084": "diez yardas",
    "1085": "van de elevación",
    "1086": "pecho",
    "1087": "barril",
    "1088": "pipa",
    "1089": "arrastrar",
    "1090": "punto de conferencia",
    "1091": "línea de noticias de ágata",
    "1092": "página",
    "1093": "mutuamente definido"
} as const;

export type UnitsOfMeasureKey = keyof typeof UnitsOfMeasure;
export type UnitsOfMeasureValue = (typeof UnitsOfMeasure)[UnitsOfMeasureKey];